/**
 * 题目查看
 * @description 题目查看，支持多题型的题目查看
 * @author mll
 * @date 2020-1-21
 */
import React from 'react';
import PropTypes from 'prop-types';

import { component_tool } from '../../../tool'
import {Tag, Tooltip} from "antd";
import {ModeInput} from "@/components/exam/subject/subjectForm/GainLossRuleComp";
let { WizComponent, WizModal, WizTypography, WizList,WizRow, WizTable } = component_tool;
const { Paragraph, Text } = WizTypography;

export default class ShowSubject extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    _title = () => {
        let { title, titleImage,typeTitle } = this.props;
        let img  = (titleImage&&titleImage['src'])?<img {...titleImage} />:null
        return [
            <Paragraph>
                {title}
            </Paragraph>,
            <>{img}</>

        ]
    }

    _option = (item) => {
        let imgView = item['imgUrl'] ? <img src={item['imgUrl']} /> : <></>
        return [
            <Paragraph>
                {item['title'] || ''}
            </Paragraph>,
            <div>{imgView}</div>
        ]
    }

    _answer = () => {
        let { answer, analysis,type } = this.props
      const { mateWay, scoreRuleGain, gainList, lossList } = this.props
      const columns = [
        {
          title: '序号',
          dataIndex: 'sort',
          key: 'sort',
          width: 60
        },
        {
          title: '得分关键词',
          dataIndex: 'list',
          key: 'list',
          render: (text, record) => {
            return (
              <div className='keyword-input-box'>
                <div className='tag-box'>
                  {text.map((tag, index) => {
                    const isLongTag = tag.words.length > 20;
                    const tagElem = (
                      <Tag className='tag-item' key={tag.sort}>
                        {isLongTag ? `${tag.words.slice(0, 20)}...` : tag.words}
                      </Tag>
                    );
                    return isLongTag ? (
                      <Tooltip title={tag.words} key={tag.sort}>
                        {tagElem}
                      </Tooltip>
                    ) : (
                      tagElem
                    );
                  })}
                </div>
              </div>
            )
          },
        },
        mateWay == 1 || !(scoreRuleGain > 0) ?{
          title: '得分权重(%)',
          dataIndex: 'ratio',
          key: 'ratio',
          width: 170,
        } : undefined,
        mateWay == 3 ? {
          title: '得分模式',
          dataIndex: '_mode',
          key: '_mode',
          width: 240,
          render: (_, record) => {
            const {mode, modeValue} = record || {}
            return <ModeInput disabled={true} mode={mode} modeValue={modeValue}/>
          }
        } : undefined,
        mateWay == 3 ? {
          title: '提示词',
          dataIndex: 'promptWord',
          key: 'promptWord',
          width: 150,
        } : undefined,
      ].filter(item => !!item);
        if(type==='Completion'){
            let _correct = ''
            let _result = []
            for (let index = 0; index < answer.length; index++) {
                const e = answer[index];
                let answer1 = ''
                let answerOther = ''
                for (let i = 0; i < e.length; i++) {
                    const _e = e[i];
                    if (i === 0) {
                        answer1 = _e
                    } else {
                        if (i === e.length - 1) {
                            answerOther += _e
                        } else {
                            answerOther += _e + '，'
                        }
                    }
                }
                let r = [<Paragraph className='exam-preview-answer-4' key={'answer1' + index}><Text>({index + 1})答案：  </Text>{answer1}</Paragraph>]
                if (answerOther !== '') {
                    r.push(<Paragraph key={'answerOther' + index}><Text>备选答案：  </Text>{answerOther}</Paragraph>)
                }
                _result.push(
                    <WizRow key={index}>{r}</WizRow>
                )
            }
            _correct = [<Text key='answer' strong>参考答案：  </Text>, _result];

        return [
            <Paragraph>{_correct}</Paragraph>,
            <Paragraph><Text strong>解析:  </Text>{analysis}</Paragraph>
        ]
        }


      if (type === 'Script') {
        return [
          <Paragraph><Text strong>答案:  </Text>{answer}</Paragraph>,
          <Paragraph><Text strong>得分规则  </Text></Paragraph>,
          <Paragraph>
            <WizTable pagination={false} columns={columns} dataSource={gainList} />
          </Paragraph>,
          <Paragraph><Text strong>解析:  </Text>{analysis}</Paragraph>
        ]
      }
        return [
            <Paragraph><Text strong>答案:  </Text>{answer}</Paragraph>,
            <Paragraph><Text strong>解析:  </Text>{analysis}</Paragraph>
        ]
    }

    render() {
        let { options } = this.props;
        return (
            <WizList
                locale={{ emptyText: ' ' }}
                header={this._title()}
                footer={this._answer()}
                dataSource={options}
                renderItem={(item) => <WizList.Item>{this._option(item)}</WizList.Item>}
                itemLayout={'vertical'}
            />
        )

    }
}

/**
 * 默认值
 */
ShowSubject.defaultProps = {
    analysis: '暂无解析',
    answer: '暂无答案',
    options: [],
    type:'Judgement'
}

/**
 * props入参校验
 */
ShowSubject.propTypes = {
    /**
     * 题干
     */
    title: PropTypes.string.isRequired,
    /**
     * 答案
     */
    answer: PropTypes.string.isRequired,
    /**
     * 答案
     */
    type: PropTypes.string.isRequired,
    /**
     * 答案解析
     */
    analysis: PropTypes.string.isRequired,
    /**
     * 题干图片的属性
     */
    titleImage: PropTypes.object,
    /**
     * 选项
     * [{title:'选项内容',imgUrl:'图片地址'}]
     */
    options: PropTypes.array,

}
